import React from 'react';
import { Container } from './styles';
import { Button, Modal, ModalProps } from '..';

type Props = ModalProps & {
    content: string;
    cancelButtonLabel: string;
    confirmButtonLabel: string;
    handleConfirmCancel: () => void;
}

const ConfirmModal: React.FC<Props> = ({
    content,
    cancelButtonLabel,
    confirmButtonLabel,
    handleClose,
    handleConfirmCancel,
    ...rest
}) => {
    return (
        <Modal
            id="confirmationmodal"
            handleClose={handleClose}
            hiddenBackButton
            {...rest}
        >
            <Container>
                <span>{content}</span>
                <Button
                    id="confirmationmodal.cancelbutton"
                    onClick={handleClose}
                >
                    {cancelButtonLabel}
                </Button>
                <Button
                    id="confirmationmodal.confirmbutton"
                    onClick={handleConfirmCancel}
                    label
                >
                    {confirmButtonLabel}</Button>
            </Container>
        </Modal>
    );
};

export { ConfirmModal };
